import { Helmet } from "react-helmet-async";
import { openPopup } from "../../../store/popupSlice"
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../component/Breadcrumb";

export default function BoltBanner({data}) {
  const dispatch = useDispatch();
  return (
    <>
      <Helmet>
        <link rel="preload" href={data && data.image} as="image" type="image/webp"/>
      </Helmet>
      <section className={`lyftclone-banner header-gap ${data && data.class}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <div className="lyftclone-banner-head cabify-banner-head">
                <Breadcrumb breadcrumbData={data?.breadcrumbData}/>
                <h1 className="heading"><span>{data && data.titlePart1}</span> {data && data.titlePart2}</h1>
                <p>{data && data.description}</p>
                <div>
                  <div>
                    <span><span></span></span>
                    <div>
                      <small>{data && data.counter1.number}</small>
                      <p>{data && data.counter1.text}</p>
                    </div>
                  </div>
                  <div>
                    <span><span></span></span>
                    <div>
                      <small>{data && data.counter2.number}</small>
                      <p>{data && data.counter2.text}</p>
                    </div>
                  </div>
                  <div>
                    <span><span></span></span>
                    <div>
                      <small>{data && data.counter3.number}</small>
                      <p>{data && data.counter3.text}</p>
                    </div>
                  </div>
                </div>
                <div className="free-trial">21 Days Free Trial | No Credit Card Required</div>
                <div className="btn-group-bolt-banner">
                  <button onClick={() => dispatch(openPopup())} className="default-btn">{data && data.btn1}</button>
                  <Link target="_blank" to={"https://www.youtube.com/watch?v=5sXs3s2RxuY"} className="default-white">{data && data.btn2}</Link>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="lyftclone-banner-image">
                <img src={data && data.image} alt="Clone banner" className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
